import { ContentfulBrand, ContentfulProduct } from '@ravago/shared/page-data/models/contentful';
import { OverviewPageBrandItem } from '@ravago/shared/page-data/models/elastic';
import { BrandCard } from '@ravago/shared/page-data/models/elements';

import { AssetUtils } from '../../lib/utils/asset/asset.utils';

export class BrandClientUtils {
  static transformToBrandCard(toTransform: ContentfulBrand | OverviewPageBrandItem, products?: Array<ContentfulProduct>, acceptWebp?: boolean): BrandCard {
    const brandCard: BrandCard = {
      id: '',
      slug: toTransform.slug,
      name: toTransform.name,
      excerpt: toTransform.excerpt,
      polymerTypes: [],
      numberOfProducts: 0,
      producer: {
        name: '',
        logo: ''
      }
    };

    if ('qualifier' in toTransform) {
      brandCard.id = toTransform.slug;
      brandCard.producer = {
        name: toTransform.producer?.name ?? '',
        logo: toTransform.producer?.logoUrl ? AssetUtils.optimizeImageIfRequired(toTransform.producer?.logoUrl, acceptWebp) : ''
      };
      brandCard.polymerTypes = toTransform.polymerTypes ?? [];
      brandCard.numberOfProducts = toTransform.numberOfItems ?? 0;
    } else {
      brandCard.id = toTransform.sys.id;
      brandCard.producer = {
        name: toTransform.producer.name,
        logo: AssetUtils.optimizeImageIfRequired(toTransform.producer.logo.url, acceptWebp)
      };
      brandCard.polymerTypes =
        products
          ?.filter((product) => product.polymerSubGroup)
          ?.map((product) => product.polymerSubGroup ?? '')
          .filter((polymerType, index, self) => polymerType && self.indexOf(polymerType) === index) ?? [];
      brandCard.numberOfProducts = products?.length ?? 0;
      brandCard.noFollow = toTransform.seoMetadata?.noFollow;
    }

    return brandCard;
  }
}
